/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * To capture and persist error in database
 */
export interface CarbonBlackApiResponseError { 
    attempt?: number;
    error_message?: string;
    error_type?: CarbonBlackApiResponseError.ErrorTypeEnum;
    occurred_at?: Date;
}
export namespace CarbonBlackApiResponseError {
    export type ErrorTypeEnum = 'PROVISIONING_RESPONSE' | 'PROVISIONING_STATUS_RESPONSE' | 'DE_PROVISIONING_RESPONSE' | 'DE_PROVISIONING_STATUS_RESPONSE';
    export const ErrorTypeEnum = {
        PROVISIONING_RESPONSE: 'PROVISIONING_RESPONSE' as ErrorTypeEnum,
        PROVISIONING_STATUS_RESPONSE: 'PROVISIONING_STATUS_RESPONSE' as ErrorTypeEnum,
        DE_PROVISIONING_RESPONSE: 'DE_PROVISIONING_RESPONSE' as ErrorTypeEnum,
        DE_PROVISIONING_STATUS_RESPONSE: 'DE_PROVISIONING_STATUS_RESPONSE' as ErrorTypeEnum
    };
}


